import { Navigate, Outlet, useLocation } from "react-router-dom";
import { GlobalLoader } from "@/components/loading/GlobalLoader";
import { useAuth } from "@/features/auth/authContext";
import { hasActiveAccountAccess } from "@/features/auth/authSession";

export function ProtectedRoute() {
  const location = useLocation();
  const { firebaseUser, loading, activationResolved, isActive } = useAuth();
  const accountIsActive = hasActiveAccountAccess(firebaseUser?.uid, isActive);

  if (loading || (firebaseUser && !activationResolved)) {
    return <GlobalLoader />;
  }

  if (!firebaseUser) {
    return <Navigate to="/entrar" replace state={{ from: location }} />;
  }

  if (!accountIsActive && location.pathname !== "/conta-pendente") {
    return <Navigate to="/conta-pendente" replace />;
  }

  if (accountIsActive && location.pathname === "/conta-pendente") {
    return <Navigate to="/painel" replace />;
  }

  return <Outlet />;
}
